import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';

const CARD_COUNT: number = 10;

// Mirrors the real layout (a property group heading + a grid of unit cards) so the
// load state matches the content shape. Rendered inside `.strata-manager-suites`,
// so the grid picks up the page's scoped grid styling.
const StrataManagerSuitesSkeleton = () => (
  <div className="strata-manager-suites-group" aria-hidden>
    <Skeleton variant="text" width="22rem" />
    <div className="strata-manager-suites-grid">
      {Array.from({ length: CARD_COUNT }, (_, index: number) => (
        <Skeleton
          key={`sm-suite-skeleton-${index}`}
          variant="rect"
          width="100%"
          height="8rem"
        />
      ))}
    </div>
  </div>
);

export default StrataManagerSuitesSkeleton;